import { render } from "./BurGerbag.vue?vue&type=template&id=0f6ea8ec"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/BurGerbag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f6ea8ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f6ea8ec', __exports__)) {
    api.reload('0f6ea8ec', __exports__)
  }
  
  module.hot.accept("./BurGerbag.vue?vue&type=template&id=0f6ea8ec", () => {
    api.rerender('0f6ea8ec', render)
  })

}


export default __exports__